/* eslint-disable @typescript-eslint/explicit-member-accessibility */
import { injectable, inject } from 'inversify';
import HttpClient from './http.service';
import StorageService from './storage.service';
import { from, of } from 'rxjs';
import asyncPermission from '@/common/utils/permission';
import Permission from '@/models/permission.model';
import { BASE_RBAC_URL } from '@/common/constant';

/** 所有权限枚举 */
export enum AuthEnum {
  /** 门店领域 */
  门店列表 = 'shop:list',
  门店运营 = 'shop:operation',
  门店管控 = 'shop:admin',
  /** B端订单 */
  B端订单列表 = 'business-order:list',
  B端订单修改 = 'business-order:edit',
  B端订单修改地推员 = 'b-order:fix-staff',
  黑卡订单退款 = 'blackcard-order:refund',
  /** C端订单 */
  C端订单列表 = 'customer-order:list',

  /** 提现 */
  提现管理 = 'withdraw:manage',
  提现查询 = 'withdraw:query',
  /** 活动 */
  活动列表 = 'activity:list',
  /** 权限 */
  权限列表 = 'permission:list',
  团队列表 = 'organization:list',
  /** 开城管理 */
  开城管理 = 'add:region:cover',
  /** 标签 */
  标签列表 = 'label:list',
  /** 店铺编辑 */
  门店编辑 = 'baseInfo:edit',
  /** 审核管理 */
  审核管理 = 'audit:admin',
  /** 代运营权限 */
  代运营门店编辑 = 'baseInfo:edit:limit',
  /** 报表 */
  BI商品报表 = 'bi:goods-list',
  BI门店统计 = 'bi:shop-summary',
  门店报表 = 'shop:all-list',
  门店操作日志 = 'shop:operation-log',
  拓店战报 = 'b.order.daily',
  服务商访店 = 'bi.agent.visit',
  城市门店明细 = 'city.shop.detail',
  黑卡门店明细 = 'blackcard.shop.detail',
  门店到期时间 = 'shop.outdate',
  门店权益到期 = 'shop.right.outdate',
  异常检查 = 'menu.error.check',
  门店营业执照查看 = 'shop.license',
  /** 德友惠提现管理 */
  德友惠提现管理 = 'menu:withdraw:admin',
  /** 全部门店（管理） */
  全部门店 = 'menu:w:shop',
  删除门店草稿和申请 = 'menu:w:deleteShop',
  地推员操作 = 'menu:w:operationStaff',
  已入驻门店报表 = 'menu:w:passshop.report',
  查看门店上游数据 = 'shop:upstream:data',
  /** 账号管理 */
  账号管理 = 'menu:account-manage',
  /** 商家平台入驻 */
  商家平台入驻 = 'merchant:join',
  /** 广告线索 */
  广告线索 = 'menu:clue:admin',
  品牌加盟线索 = 'brand:save:info',
  黑卡留资 = 'menu:blackcard.lead',
  /** 绑定门店代运营人员 */
  绑定门店代运营人员 = 'agent:bind',
  /** 修改第三方店铺绑定 */
  修改第三方店铺绑定 = 'change:third',
  /** 系统追踪 */
  系统追踪 = 'system:log',
  /** 设置推广通权限 */
  设置推广通权限 = 'ad:staff',
  /** 推广通广告投放确认 */
  推广通广告投放确认 = 'boss-confirmation-ad',
  /** 代运营管理 */
  代运营管理 = 'menu:agencyOperation',
  代运营管理操作 = 'agent_city_relation:all',
  /** 商品管理 */
  平台标准商品管理 = 'menu:platformProductOperation',
  品牌标准商品管理 = 'menu:KaPlatformProductOperation',
  批量商品管理 = 'menu:LeadingSpuOperation',
  /** 批量导入品牌门店操作权限 */
  品牌门店导入 = 'operation: batch-import-brand-shops',
  /** 编辑广告主电话 */
  编辑广告主电话 = 'operation: advertiser-mobile-phone-number',
  /** 标品活动报名 */
  标品活动报名 = 'operation: bind-platformProduct',
  /** 标品视频管理 */
  标品视频管理 = 'operation:spu-videos-manage',
  /** 门店视频管理 */
  门店视频管理 = 'operation:shop-videos-manage',
  /** 圈店推送 */
  圈店推送 = 'push:push-setting',
  /** 下载二维码海报 */
  下载二维码海报 = 'operation:download-qrcode-poster',
  /** B端订单追加备注编辑权限 */
  编辑B端订单追加备注 = 'operation: BOrder-remark',
  /** 入驻门店视频管理 */
  入驻门店视频管理 = 'operation:create-shop-videos-manage',
  /** 人工干预商家平台入驻 */
  人工干预商家平台入驻 = 'operation:intervention-mechant-join',
  /** C端订单操作（通用） */
  C端订单操作 = 'operation:c-order',
  /** 菜单C端订单 */
  菜单C端订单列表 = 'menu:COrder-list',
  菜单推广通余额数据 = 'menu:ad-campaigns-balance',
  菜单门店巡检记录 = 'menu:shop-inspection-record',
  查看导出门店信息 = 'view:export-shop-info',
  门店子账号管理 = 'operation:shop-staff',
  菜单品牌管理 = 'menu:brand-admin',
  新增品牌 = 'brand:add',
  品牌编辑 = 'brand:edit',

  设置考核门店 = 'examine:shop',
  门店控价考核调研表 = 'examine:summary',
  调研结果汇总 = 'examine:research',
  参数配置 = 'menu:parameter-config',

  /** 提现页面 */
  提现申请管理 = 'withdraw:apply-list',
  提现审核管理 = 'withdraw:examine-list',
  提现明细管理 = 'withdraw:detail-list',
  结算单管理 = 'withdraw:settlement-list',

  /** 提现操作 */
  提现转账 = 'withdraw:transfer',
  提现审核 = 'withdraw:examine',
  提现驳回 = 'withdraw:reject',

  /** 商品管理 */
  服务详情属性管理 = 'menu:spu-manage',
  服务详情属性复制 = 'menu:spu-copy',
  服务详情属性删除 = 'menu:spu-delete',
  服务详情属性编辑 = 'menu:spu-edit',
  服务详情属性新增 = 'menu:spu-add',
  服务详情默认设置 = 'menu:spu-default',
  默认内容编辑 = 'menu:spu-edit-content',
  默认内容删除 = 'menu:spu-delete-content',


  /** 品牌代运营 */
  /** 按钮 */
  品牌赠送天数 = 'operation:brand-give-days',
  导入老板电话 = 'operation:brand-import-phone',
  品牌复制链接 = 'operation:brand-copy-link',

  /** 菜单 */
  门店入驻列表 = 'menu:shop-enter-list',
  /** 按钮 */
  批量加入批次 = 'menu:shop-enter-batch',
  加入批次 = 'menu:shop-enter-batch-add',
  入驻门店删除 = 'menu:shop-enter-batch-delete',
  入驻门店审核 = 'menu:shop-enter-batch-audit',
  入驻审核通过 = 'menu:shop-enter-batch-audit-pass',
  入驻审核修改 = 'menu:shop-enter-batch-audit-reject',

  品牌录音列表 = 'menu:brand-recording-list',
  门店录音列表 = 'menu:shop-recording-list',

  批次管理 = 'menu:shop-enter-batch-manage',
  /** 按钮 */
  添加批次 = 'menu:shop-enter-add-batch',
  修改批次 = 'menu:shop-enter-batch-edit',
  添加批次内门店 = 'menu:shop-enter-batch-add-shop',
  移除批次内门店 = 'menu:shop-enter-batch-remove-shop',
  查看批次内门店 = 'menu:shop-enter-batch-view-shop',
  提交代运营审核 = 'menu:shop-enter-batch-audit-agency',
  品牌相册模版管理 = 'menu:brand-album-template',
  品牌相册模版编辑 = 'brand:brand-album-template-edit',
  品牌相册模版删除 = 'brand:brand-album-template-delete',
  门店相册模版设置 = 'brand:shop-album-template-Settings',

  /** 品牌代运营 */
  品牌门店复合 = 'menu:brand-shop-composite',
  /** 按钮 */
  品牌门店复合审核 = 'menu:brand-shop-composite-audit',


  查看手机号 = 'menu:shop-enter-batch-view-phone',

  部门管理 = 'menu:department-manage',

  退出品牌 = 'menu:brand-shop-composite-exit',
  分类属性管理 = 'menu:category-manage',
  上门服务编辑 = 'menu:edit-on-site',
  批量删除门店商品 = 'menu:batch-delete-store',
  门店抽佣 = 'menu:shop-commission',
  B端广告订单修改 = 'operation:order-modification',
  运营工作台 = 'menu:operation-workbench',
  工作台上传 = 'menu:operation-workbench-upload',
  门店实名认证链接 = 'menu:authentication-link',
  报表下载 = 'menu:bi-download',

  发票管理 = 'menu:invoice-manage',
  申请开票 = 'menu:invoice-apply',
  发票查看 = 'menu:invoice-view',
  抬头管理 = 'menu:invoice-title-manage',
  客资信息 = 'menu:customer-funding',
  品牌门店客资 = 'menu:customer-funding-ka',
  门店解绑 = 'menu:shop-unbind',
  菜单财务目标考核 = 'menu:financial-target-assessment',
  绩效数据导出 = 'meun:export-performance-data',
  批量释放门店地推员 = 'menu:batch-release-stores',
  商品信息推送至高德 = 'menu:push-spu-to-high-deed',
  订单自动结算明细 = 'menu:order-settlement-detail',
  退单列表 = 'menu:refund-list-b',
  高德财务涉税填报 = 'menu:amap-financial-tax-report',

  救援收入成本汇总 = 'menu:rescue-income-cost',
  道路救援涉税填报 = 'menu:rescue-financial-tax-report',

  平台标品商品管理 = 'button:platform-product',
  品牌标品商品管理 = 'button:ka-platform-product',
  多门店商品管理 = 'button:multi-store-product',
  门店商品管理 = 'button:store-product',
  发票操作管理 = 'button:invoice-operation',
  发票操作开票 = 'button:invoice-operation-apply',
  提现列表操作管理旧 = 'button:withdraw-list',

  虚拟POI管理 = 'menu:virtual-poi',
  虚拟POI新增 = 'button:virtual-poi-add',
  虚拟POI编辑 = 'button:virtual-poi-edit',
  收款凭证管理 = 'menu:voucher-manage',
  收款凭证编辑 = 'button:voucher-edit',
  查看收款凭证 = 'button:voucher-view',
  查看付款凭证 = 'button:payment-view',
  取消权益 = 'button:cancel-privilege',
  修改门店信息草稿删除 = 'button:draft-delete',
  店铺修改记录 = 'button:shop-edit-record',
  虚拟点位修改半径 = 'button:virtual-poi-edit-radius',
  信息编辑 = 'button:info-edit',
  修改店铺类型 = 'button:shop-type-edit',
  业绩统计 = 'button:bi-performance-statistics',
  批量修改点位半径 = 'button:batch-edit-radius',
  虚拟门店扎点管理 = 'button:virtual-point-manage',
  运营数据大屏 = 'menu:operation-data-screen',


  // 二手车权限
  二手车店铺列表 = 'menu:car-shop-list',
  二手车绑定门店代运营人员 = 'button:car-agent-bind',
  二手车B端订单列表 = 'menu:car-order-list',
  二手车B端订单待支付列表 = 'menu:car-order-list-pending',
  二手车B端订单修改 = 'button:car-order-edit',
  二手车B端订单报表 = 'menu:car-order-report',
  二手车全部审核列表 = 'menu:car-order-list-all',
  二手车待审核列表 = 'menu:car-order-list-approval',
  二手车收款凭证管理 = 'menu:car-voucher-manage',
  二手车收款凭证编辑 = 'button:car-voucher-edit',
  二手车查看收款凭证 = 'button:car-voucher-view',
  二手车查看付款凭证 = 'button:car-payment-view',
  二手车B端自动结算明细 = 'menu:car-order-settlement',
  二手车B端退单列表 = 'menu:car-refund',
  二手车客资列表 = 'menu:car-bi=-customer-list',

}

/** 菜单权限 set */
export const AuthMenuSet: Set<AuthEnum> = new Set([
  AuthEnum.门店列表,
  AuthEnum.B端订单列表,
  AuthEnum.C端订单列表,
  AuthEnum.提现查询,
  AuthEnum.提现管理,
  AuthEnum.活动列表,
  AuthEnum.权限列表,
  AuthEnum.团队列表,
  AuthEnum.开城管理,
  AuthEnum.标签列表,
  AuthEnum.审核管理,
  AuthEnum.代运营门店编辑,
  AuthEnum.BI商品报表,
  AuthEnum.BI门店统计,
  AuthEnum.门店报表,
  AuthEnum.门店操作日志,
  AuthEnum.拓店战报,
  AuthEnum.服务商访店,
  AuthEnum.城市门店明细,
  AuthEnum.黑卡门店明细,
  AuthEnum.门店到期时间,
  AuthEnum.门店权益到期,
  AuthEnum.异常检查,
  AuthEnum.德友惠提现管理,
  AuthEnum.全部门店,
  AuthEnum.已入驻门店报表,
  AuthEnum.查看门店上游数据,
  AuthEnum.账号管理,
  AuthEnum.商家平台入驻,
  AuthEnum.广告线索,
  AuthEnum.品牌加盟线索,
  AuthEnum.黑卡留资,
  AuthEnum.绑定门店代运营人员,
  AuthEnum.系统追踪,
  AuthEnum.设置推广通权限,
  AuthEnum.推广通广告投放确认,
  AuthEnum.代运营管理,
  AuthEnum.代运营管理操作,
  AuthEnum.平台标准商品管理,
  AuthEnum.批量商品管理,
  AuthEnum.品牌标准商品管理,
  AuthEnum.黑卡订单退款,
  AuthEnum.品牌门店导入,
  AuthEnum.编辑广告主电话,
  AuthEnum.标品活动报名,
  AuthEnum.标品视频管理,
  AuthEnum.门店视频管理,
  AuthEnum.圈店推送,
  AuthEnum.下载二维码海报,
  AuthEnum.编辑B端订单追加备注,
  AuthEnum.入驻门店视频管理,
  AuthEnum.人工干预商家平台入驻,
  AuthEnum.菜单C端订单列表,
  AuthEnum.C端订单操作,
  AuthEnum.菜单推广通余额数据,
  AuthEnum.菜单门店巡检记录,
  AuthEnum.查看导出门店信息,
  AuthEnum.门店子账号管理,
  AuthEnum.菜单品牌管理,
  AuthEnum.新增品牌,
  AuthEnum.品牌编辑,
  AuthEnum.设置考核门店,
  AuthEnum.门店控价考核调研表,
  AuthEnum.调研结果汇总,
  AuthEnum.提现申请管理,
  AuthEnum.提现审核管理,
  AuthEnum.提现明细管理,
  AuthEnum.结算单管理,
  AuthEnum.提现转账,
  AuthEnum.提现审核,
  AuthEnum.提现驳回,
  AuthEnum.参数配置,
  AuthEnum.服务详情属性管理,
  AuthEnum.服务详情属性复制,
  AuthEnum.服务详情属性删除,
  AuthEnum.服务详情属性编辑,
  AuthEnum.服务详情属性新增,
  AuthEnum.服务详情默认设置,
  AuthEnum.默认内容编辑,
  AuthEnum.默认内容删除,

  AuthEnum.品牌赠送天数,
  AuthEnum.导入老板电话,
  AuthEnum.品牌复制链接,
  AuthEnum.门店入驻列表,
  AuthEnum.批量加入批次,
  AuthEnum.加入批次,
  AuthEnum.入驻门店删除,
  AuthEnum.入驻门店审核,
  AuthEnum.入驻审核通过,
  AuthEnum.入驻审核修改,
  AuthEnum.批次管理,
  AuthEnum.添加批次,
  AuthEnum.修改批次,
  AuthEnum.添加批次内门店,
  AuthEnum.移除批次内门店,
  AuthEnum.查看批次内门店,
  AuthEnum.提交代运营审核,
  AuthEnum.品牌门店复合,
  AuthEnum.品牌门店复合审核,
  AuthEnum.退出品牌,
  AuthEnum.分类属性管理,
  AuthEnum.上门服务编辑,
  AuthEnum.批量删除门店商品,
  AuthEnum.门店抽佣,
  AuthEnum.B端广告订单修改,
  AuthEnum.运营工作台,
  AuthEnum.工作台上传,
  AuthEnum.门店实名认证链接,
  AuthEnum.报表下载,
  AuthEnum.发票管理,
  AuthEnum.申请开票,
  AuthEnum.发票查看,
  AuthEnum.抬头管理,
  AuthEnum.客资信息,
  AuthEnum.品牌门店客资,
  AuthEnum.门店解绑,
  AuthEnum.菜单财务目标考核,
  AuthEnum.绩效数据导出,
  AuthEnum.批量释放门店地推员,

  AuthEnum.二手车店铺列表,
  AuthEnum.二手车B端订单列表,
  AuthEnum.二手车B端订单待支付列表,
  AuthEnum.二手车全部审核列表,
  AuthEnum.二手车待审核列表,
  AuthEnum.商品信息推送至高德,
  AuthEnum.订单自动结算明细,
  AuthEnum.退单列表,
  AuthEnum.高德财务涉税填报,
  AuthEnum.门店录音列表,
  AuthEnum.品牌录音列表,
  AuthEnum.救援收入成本汇总,
  AuthEnum.道路救援涉税填报,
  AuthEnum.业绩统计,
  AuthEnum.运营数据大屏,

  AuthEnum.平台标品商品管理,
  AuthEnum.品牌标品商品管理,
  AuthEnum.多门店商品管理,
  AuthEnum.门店商品管理,
  AuthEnum.发票操作管理,
  AuthEnum.发票操作开票,
  AuthEnum.提现列表操作管理旧,
  AuthEnum.虚拟POI管理,
  AuthEnum.虚拟POI新增,
  AuthEnum.二手车B端订单报表,
  AuthEnum.部门管理,
  AuthEnum.收款凭证管理,
  AuthEnum.二手车收款凭证管理,
  AuthEnum.二手车B端自动结算明细,
  AuthEnum.二手车B端退单列表,
  AuthEnum.二手车客资列表,

]);
interface InterfacePagination {
  lastPage: number;
  page: number;
  pageSize: number;
  total: number;
}
export interface PermissionListRes extends InterfacePagination {
  list: Permission[];
}
export interface OrganizationListRes extends InterfacePagination {
  list: Array<{
    id: number;
    name: string;
  }>;
}

export interface InterfaceOrganizationRole {
  roleId: number;
  roleName: string;
}

export interface InterfaceOrganizationRoleRes {
  roleName: string;
  roleID: number;
  permission: Array<{
    permissionId: number;
    permissionName: string;
  }>;
}

interface OrganizationUserRoleRes {
  [roleId: number]: Array<{
    phone: string | null;
    roleId: number;
    roleName: string;
    userId: number;
    userName: string | null;
  }>;
}
@injectable()
export default class PermissionService {
  @inject(HttpClient)
  protected http!: HttpClient;

  @inject(StorageService)
  protected storage!: StorageService;

  /**
   * 查询多个权限
   *
   * @param {AuthEnum[]} pnames
   * @return {*}  {Promise<Observable<KeyObject<boolean>>>}
   * @memberof PermissionService
   */
  async asyncPermissions(pnames: AuthEnum[]) {
    try {
      const permissions = asyncPermission(pnames);
      if (permissions) {
        return from(permissions);
      } else {
        return of({});
      }
    } catch (error) {
      return of({});
    }
  }

  /**
   * 创建权限
   */
  async createPermission(name: string, path: string): Promise<number> {
    try {
      const result = (await this.http.post('rbac/permission/add', {
        name,
        path,
      })) as number;

      return result;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  /**
   * 给组织创建角色
   * @param organizationId 组织id
   * @param name
   * @returns 返回新创建角色的id
   */
  async createRoleOfOrganization(organizationId: string, name: string) {
    try {
      const res = (await this.http.post(
        'rbac/organization/role/add',
        {
          organizationId,
          name,
        },
      )) as number;
      return res;
    } catch (error) {
      throw error;
    }
  }

  /**
   * 给角色添加权限
   * @param roleId 角色id;
   * @param permissionIds 权限id
   * @returns
   */
  async addPermissionToRole(params: {
    roleId: string;
    permissionIds: string[];
  }) {
    try {
      const res = await this.http.post(
        `${BASE_RBAC_URL}/role/${params.roleId}/permission`,
        {
          permissionIds: params.permissionIds,
        },
      );
      return res;
    } catch (error) {
      throw error;
    }
  }

  /**
   * 给组织的角色添加权限
   * @param params
   * @returns
   */
  async addPermissionToOrganizationRole(params: {
    roleId: number;
    organizationId: string;
    permissionIds: number[];
  }) {
    try {
      const { roleId, organizationId, permissionIds } = params;
      const res = await this.http.post(
        'rbac/organization/role/permission/add',
        {
          permissionIds,
          roleId,
          organizationId,
        },
      );
      return res;
    } catch (error) {
      throw error;
    }
  }

  /**
   * 删除组织角色的权限
   * @param params {roleId: 角色id, organizationId: 组织id，permissionIds: 权限id，多个权限以","分隔 }
   * @returns
   */
  async deletePermissionOfOrganizationRole(params: {
    roleId: number;
    organizationId: string;
    permissionIds: string;
  }) {
    try {
      const { roleId, organizationId, permissionIds } = params;
      const res = await this.http.delete(
        'rbac/organization/role/permission/delete',
        {
          params: {
            roleId,
            organizationId,
            permissionIds,
          },
        },
      );
      return res;
    } catch (error) {
      throw error;
    }
  }

  /**
   * 删除组织角色
   * @param roleID
   * @param organizationId
   * @returns
   */
  async deleteRoleOfOrganization(roleId: number, organizationId: string) {
    try {
      const res = await this.http.delete(
        'rbac/organization/role/delete',
        {
          params: {
            organizationId,
            roleId,
          },
        },
      );
      return res;
    } catch (error) {
      throw error;
    }
  }

  /**
   * 删除角色的权限
   * @param roleId  角色id
   * @param permissionIds  `1,2,3`
   * @returns
   */
  async deletePermissionOfRole(roleId: string, permissionIds: string) {
    try {
      const res = await this.http.delete(
        `${BASE_RBAC_URL}/role/${roleId}/permission/${permissionIds}`,
      );
      return res;
    } catch (error) {
      throw error;
    }
  }

  /**
   * 删除已有权限
   * @param {string} id 权限id
   * @returns {string}
   */
  async deletePermission(id: string): Promise<string> {
    try {
      const result = (await this.http.delete(
        `rbac/permission/delete/${id}`,
      )) as string;
      // '删除成功'
      return result;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  /**
   * 获取全部权限列表
   * @param params
   * @returns
   */
  async permissionList(dataParams: {
    page: number;
    pageSize: number;
    name?: string; // pathname?: string
  }) {
    const params = {
      page: dataParams.page,
      pageSize: dataParams.pageSize,
      permission_name: dataParams.name,
    };
    try {
      const data = (await this.http.get('rbac/permissions/list', {
        params,
      })) as PermissionListRes;
      return data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  /**
   * 获取团队列表
   * @param params
   * @returns
   */
  async orgList(params: {
    pageSize?: number;
    page: number;
    name?: string;
  }): Promise<OrganizationListRes> {
    const res = (await this.http.get('rbac/organization/list', {
      params,
    })) as OrganizationListRes;

    return res;
  }

  /**
   * 删除团队
   * @param {string} orgId 团队id
   * @returns
   */
  async deleteOrganization(orgId: string): Promise<string> {
    try {
      const result = (await this.http.delete(
        `rbac/organization/delete/${orgId}`,
      )) as string;
      return result;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  /**
   * 创建新团队
   * @param {string} name 团队名称
   * @returns
   */
  async createOrganization(name: string): Promise<number> {
    try {
      const result = (await this.http.post('rbac/organization/add', {
        name,
      })) as number;
      return result;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  /**
   * 新增团队成员
   * @param params
   */
  async addOrgMember(params: {
    userName?: string;
    phone: string;
    orgId: string;
    orgRoleId: string[];
  }) {
    const res = (await this.http.post(
      'rbac/organization/user/add',
      {
        roleId: params.orgRoleId,
        organizationId: params.orgId,
        phone: params.phone,
        name: params.userName || '',
      },
    )) as string;

    return res;
  }

  /**
   * 删除团队下某个成员
   * @param orgId
   * @param userId
   * @returns
   */
  async deleteOrgMember(orgId: string, userId: string) {
    const res = (await this.http.delete(
      'rbac/organization/user/delete',
      {
        params: {
          organizationId: orgId,
          userId,
        },
      },
    )) as null;

    // @notice 返回null 代表 删除成功！！！
    return res;
  }

  /**
   * 获取团队所有角色列表
   * @param id 团队id
   * @returns
   */
  async organizationRoleList(id: string): Promise<InterfaceOrganizationRole[]> {
    const result = (await this.http.get(
      'rbac/organization/role_list',
      {
        params: {
          organizationId: id,
        },
      },
    )) as InterfaceOrganizationRole[];
    return result;
  }

  /**
   * 获取团队角色
   * @param {string} id 团队id
   * @returns
   */
  async getOrganizationRoleList(id: string) {
    try {
      const rolePermissionRes = (await this.http.get(
        'rbac/organization/role-permission',
        {
          params: {
            organizationId: id,
          },
        },
      )) as InterfaceOrganizationRoleRes[];

      return rolePermissionRes;
    } catch (error) {
      throw error;
    }
  }

  /**
   * 获取团队下成员列表（成员的角色）
   * @param id 团队id
   */
  async getOrgMemberList(id: string) {
    const userRoleRes = (await this.http.get(
      'rbac/organization/user-role', {
      params: {
        organizationId: id,
      },
    },
    )) as OrganizationUserRoleRes;

    if (userRoleRes) {
      const userRoleMap = new Map(Object.entries(userRoleRes));
      const userRoleList: Array<{
        phone: string;
        name: string;
        id: string;
        roles: Array<{
          id: string;
          name: string;
        }>;
      }> = [];

      for (const [key, value] of userRoleMap) {
        const item = {
          id: key,
          name: value[0].userName || '',
          phone: value[0].phone || '',
          roles: value.map(
            (data: {
              phone: string | null;
              roleId: number;
              roleName: string;
              userId: number;
              userName: string | null;
            }) => {
              return {
                id: data.roleId,
                name: data.roleName,
              };
            },
          ),
        };
        userRoleList.push(item);
      }

      return userRoleList;
    }
  }
}
